import MyButton from '@/components/UI/myButton.vue'
// import MyInput from '@/components/UI/myInput.vue'

export default [
    MyButton,
    // MyInput
]